export const testRegex = (value: string, regExp: string) => {
    const regexObject = new RegExp(regExp);
    return regexObject.test(value);
};
